import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // refetchInterval: false,
      // retry: false,
      // retryOnMount: false,
      // refetchOnMount: false,
    },
  },
});
